"use client";

import React from "react";
import { useServiceArea } from "@/src/hooks/serviceArea/useServiceArea";

/**
 * Delivery-area notice for outlets that only serve part of the map — their
 * city, chosen areas, or a distance. Renders nothing for every other outlet.
 */
export function ServiceAreaNotice({ outletId }: { outletId?: string }) {
  const { area, blocked } = useServiceArea(outletId);
  if (!area) return null;

  return (
    <div className="mb-3 flex">
      <span className="gl-runglow inline-flex max-w-full items-center gap-2.5 py-3 pl-4 pr-5">
        <span className="gl-runglow-dot shrink-0" aria-hidden />
        <span className="shrink-0" style={{ color: "var(--coral, #F26250)" }}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
            <circle cx="12" cy="9" r="2.5" />
          </svg>
        </span>
        <span className="line-clamp-2 min-w-0 text-[15px] font-bold leading-snug tracking-[0.01em]">
          {blocked ? area.outsideNotice : area.homeNotice}
        </span>
      </span>
    </div>
  );
}
